import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import * as dayjs from 'dayjs';

//避免跨域时，后端session.getAttribute方法取到的值为null
axios.defaults.withCredentials = true;

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .mount('#app');
axios.defaults.withCredentials = true;
